export default {"src":"/uk/_next/static/media/black-rock.b6a3a985.svg","height":221,"width":1552,"blurWidth":0,"blurHeight":0};